import React, { Component } from 'react'

import Header from './common/EmptyHeader'
import Footer from './common/GreenFooter'

class TermsOfUse extends Component {
    render() {
        return (
            <div className="static-page term-of-use">
                <Header />
                <main>
                    <div className="container-fluid" style={{ marginBottom: '120px' }}>
                        <div className="row" style={{ paddingTop: '40px' }}>
                            <div className="container">
                                <div className="row" style={{ marginBottom: '16px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <h1>條款及細則</h1>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '12px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        歡迎使用 CellWine 銅板酒窖服務（以下簡稱本網站），本網站及相關服務是由英屬開曼群島商若堤股份有限公司台灣分公司所提供，歡迎您使用【CELLWINE銅板酒窖】主打一瓶就能存，以瓶計月費，無須租用過多空間，依照您實際使用需求，享受專業酒窖儲藏的優質服務。
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '32px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        本使用條款係針對使用【CELLWINE銅板酒窖】之使用者所簽訂之服務合約。在您同意使用本網站及相關服務之前，煩請撥冗閱讀本使用條款，同意後再使用本網站及相關服務，您得將收藏之葡萄酒委託本公司儲藏、管理、運送；若您不同意本條款，將無法享受本網站及相關服務。一旦您註冊本網站之帳號，將視為您已閱讀、了解並同意下列條款：
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '16px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>一、使用者註冊及帳號維護</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                    <div className="row" style={{ marginBottom: '8px' }}>
                                        <div className="col-12">
                                            <div>
                                                <ol>
                                                    <li>本網站目前僅提供「e-mail」或「手機電話號碼」方式，下載Cellwine App並註冊帳號成為會員後，得始預約專業適酒窖儲藏服務，於註冊時請依本網站指示確實填寫，並應自行維護、更新相關帳號內容以及通訊地址等基本資料，如有不實或因未更新，導致後續產生法律問題或無法順利使用本網站之服務，使用者應自行承擔相關責任。</li>
                                                    <li>本網站僅提供年滿20歲之完全行為能力人註冊帳號並使用，若您未滿20歲，應請您的法定代理人（如：父母、監護人等）閱讀、了解並同意本網站所有條款之內容後，再使用本網站之服務。當您註冊並使用本網站所提供之服務，即視為您的法定代理人已閱讀、了解並同意本網站之所有條款內容，且允許您使用本網站進行相關法律行為。</li>
                                                    <li>有下列情形之一者，本公司得拒絕使用者之註冊申請；已註冊者得停權、刪除帳號及帳戶：
                                                        <ol>
                                                            <li>未依照本網站之規定如實填寫基本資料或填寫有誤者；</li>
                                                            <li>冒用他人名義進行申請者；</li>
                                                            <li>不具完全行為能力者；</li>
                                                            <li>其他經本公司認定不符合申請條件者。</li>
                                                         </ol>
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>二、服務內容與收費</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                    <div className="row" style={{ marginBottom: '8px' }}>
                                        <div className="col-12">
                                            <div>
                                                <ol>
                                                    <li>使用者須先下載本公司提供之Cellwine App並註冊帳號成為會員後，得向本公司預約專業適溫葡萄酒酒窖儲藏服務，由會員將其收藏之葡萄酒品，親送或寄送至本公司指定處所，由本公司或本公司指定人員收取點交確認 (若為寄送者則開箱全程錄影)，並開立收據後，儲藏於本公司管理之葡萄酒酒窖內，本公司保證前揭酒窖之溫度適於葡萄酒儲藏。</li>
                                                    <li>本公司收到會員送達之葡萄酒品後，由本公司指派員工為會員拍攝酒品現況 (含正面及背面)、整理數量、貼標、編號紀錄、歸箱列管，以及後續酒標比對、資料查詢、建檔登錄、編輯修改及連結顯示國際參考價格等相關服務，完成後將上開資料匯入會員之Cellwine App帳號酒窖庫存紀錄，本項服務將酌收一次性之資料處理費。</li>
                                                    <li>會員得按本公司開放預約時間，以Cellwine App或至Cellwine網站選擇指定日期，並通知本公司將其儲藏指定之酒品，移至本公司處理中心供會員親自取回，或以指定(低溫)宅配運送之方式、送達至指定處所，交付予會員或其指定之人士。</li>
                                                    <li>關於服務內容與收費方式若有更新，均依本公司最新公告為準。</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>三、管理期間與費用計算</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                    <div className="row" style={{ marginBottom: '8px' }}>
                                        <div className="col-12">
                                            <div>
                                                <ol>
                                                    <li>會員每次委託本公司管理之期間，以1個月為單位。</li>
                                                    <li>本公司之管理服務收取服務費，費用包括：
                                                        <ol>
                                                            <li>資料處理費(一次性計費)：即第二條第(2)項服務內容之費用，包含CELLWINE系統維運費、每瓶瓶身保護包材與攝影紀錄費。</li>
                                                            <li>儲存費(按月計費)：即第二條第(1)項儲存服務之費用。</li>
                                                            <li>出窖與運送服務費 (每次按瓶數計費)：  即第二條第(3)項服務內容之費用，包含包材費、作業手續費及運送業者冷藏物流費。</li>
                                                            <li>包材費(每單次計費)：當會員或指定人士親自前來拿取其儲存酒品時，若有需要本公司提供紙箱或手提袋時所收取之費用。</li>
                                                        </ol>
                                                    <li>本項各款費用，均以會員登記之信用卡，於本公司依各該相關服務流程請款時支付之，相關費用之發票將於會員信用卡扣款成功後7日內郵寄至會員已提供之地址或指定地點。</li>
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>四、責任歸屬</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                    <div className="row" style={{ marginBottom: '8px' }}>
                                        <div className="col-12">
                                            <div>
                                                <ol>
                                                    <li>本公司管理期間，若有故意過失毀損、滅失會員之酒品，本公司應依照當日wine-searcher網站查詢所得之國際均價八折換算當日匯率所得之新台幣金額參考賠償，最高賠償金額上限為每瓶新台幣3000元；若為其他部分(如酒標、酒盒)之損壞，則由雙方協議之。</li>
                                                    <li>本公司管理期間，若突發天災(如火災，地震)、或其他不可抗力(如無故停電而導致酒窖溫度變化)等非可歸責本公司之因素所致會員酒品之毀損、滅失或其他損壞之情事，本公司不負賠償責任。</li>
                                                    <li>本公司依第二條第(1)項約定，將會員指定之葡萄酒品送交宅配運送業者後，其運送風險與利益由會員承擔，概與本公司無涉。</li>
                                                    <li>會員於使用銅板酒窖儲存服務期間內，應隨時保持其登記之信用卡得有效扣款，若有扣款未成之情事，經本公司限期催告仍未繳清費用，本公司有權提前終止合約，並自扣款失敗日起算加計違約金每瓶每日1元，本公司併得留置會員的酒品，會員需全額付清後始得取回。</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>五、保密義務</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>本公司及本公司員工對於會員之個人資料(包含但不限於姓名、地址或得識別個人身分之資料均屬之)、儲藏酒品品項、數量等資訊，均應負保密義務，縱令於本合約服務終止後亦同。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>六、著作權歸屬</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>本公司員工執行第二條第(2)項之服務，其全程拍攝、錄影記錄及後製整理、編輯之圖文、影像資料之著作財產權，均歸本公司所有，本公司於本合約管理服務、統計大數據及建立資料庫所必要之範圍內，得無償利用。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>七、免責條款</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>於符合中華民國法令、本服務條款及隱私權政策之範圍內，會員得自由使用本網站及相關服務。倘有違反法令或本公司所公布之條款，或有不正確操作、提供錯誤資料、侵害他人權益、出於惡意或損害他人意圖等違法情事，均與本公司之人員無關，衍生之風險及法律責任，或因而造成本公司及所屬人員或其他第三人之損害，會員均應自行承擔及賠償。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>八、帳號密碼被冒用之處理</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>本公司知悉會員之帳號密碼遭冒用或有冒用之虞時，得暫停該帳號之使用權限及後續利用，無需事先通知。但會員若提出其他證據證明並無冒用之情事，經本公司審酌確定無誤或經司法判決確定後，得回復該帳號之權限。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>九、損害賠償</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>會員若因違反中華民國法令或本網站各項條款之情事，導致他人受有損害者，應自行承擔損害賠償之責；若因會員之違法行為導致本公司商譽或其他權利受損，本公司有權要求賠償或為其他必要之處置。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>十、管轄條款</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>雙方若因本合約之履行發生爭議，應先本諸善意誠信原則協商解決，若協商不成而有訴訟之必要，均同意以臺灣台北地方法院為第一審管轄法院。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>十一、一部無效之情形</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>本條款任何一部若有無效之情況，不影響其他部份之效力。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '8px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" style={{ marginBottom: '12px' }}>
                                        <h2>十二、條款修訂</h2>
                                    </div>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                            <div className="col-12">
                                                <div>本網站將視實際需求隨時修改並更新使用者條款及隱私權政策，並公告於本網站中，本公司將不會另外個別通知使用者，建議您隨時注意並確認本網站之條款，以維護您瀏覽本網站之安全及相關權益；如不同意本公司之修正或更新，請即時向本公司終止服務，惟若繼續使用本網站及相關服務，則視同已接受條款之修正及更新。如您對上述內容或本網站有任何不明瞭之處或意見，請立即與服務人員聯繫，Email: service@cell.wine</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        )
    }
}

export default TermsOfUse
